import { Stack } from '@mui/material';
import type {
  AzureRestorePointData,
  InventoryResource,
  SnapshotLocation,
} from '@repo/api-gw-sdk';
import type { PropsWithChildren } from 'react';

import { ButtonWithIcon } from '@/components/buttons/buttonWithIcon';
import { Panels } from '@/components/panels/panels';
import { useViewParameters } from '@/contexts/navigation';
import { useRoles } from '@/contexts/useRoles';
import { useWorkspace } from '@/contexts/useWorkspace';

export const OtherSnapshotsDetails = ({
  snapshotDetails,
  azureRestorePoint,
  children,
  resource,
  time,
}: PropsWithChildren<{
  time: string | Date;
  snapshotDetails?: {
    providerVolumeId: string;
    snapshotLocation: SnapshotLocation;
  }[];
  azureRestorePoint?: AzureRestorePointData;
  resource: InventoryResource;
}>) => {
  const { removeParam } = useViewParameters();
  const onClose = () => {
    rightPanel.setIsOpen(false);
    removeParam('id');
  };

  const onBack = () => {
    rightPanel.setComponent({
      panel: Panels.InventoryInstance,
      props: { id: resource.id, onClose, initialTab: 'eon-snapshots' },
    });
  };

  const { isAuthorizedResource } = useRoles();
  const { rightPanel } = useWorkspace();
  return (
    <Stack marginLeft={'212px'} gap='24px'>
      {children}
      <Stack alignItems='end'>
        <ButtonWithIcon
          variant='outlined'
          icon='material-symbols-join-right-rounded'
          isAuthorized={isAuthorizedResource('create:jobs', resource)}
          text={'Convert to Eon'}
          onClick={() => {
            rightPanel.setIsOpen(true);
            rightPanel.setComponent({
              panel: Panels.ConvertToSingleEonSnapshot,
              props: {
                onClose,
                onBack,
                resource: resource,
                snapshotDetails,
                azureRestorePoint,
                snapshotDate: time,
              },
            });
          }}
        />
      </Stack>
    </Stack>
  );
};
